const sectionCardFeatureCss = `
[data-type='section-card-feature'] .container {
  padding-inline: 0 !important;
}

[data-type='section-card-feature'] .card-feature-wrapper {
  padding-block: 40px;
}

[data-type='section-card-feature'] .card-feature-wrapper[data-position='left'] .card-feature-container {
  flex-direction: row;
}

[data-type='section-card-feature'] .card-feature-wrapper[data-position='right'] .card-feature-container {
  flex-direction: row-reverse;
}

[data-type='section-card-feature'] .card-feature-container {
  display: flex;
  gap: 32px;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-left {
  flex: 1;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-left .card-feature-image {
  width: 100%;
  aspect-ratio: 1/1;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-left .card-feature-image img,
[data-type='section-card-feature'] .card-feature-container .card-feature-left .card-feature-image video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right {
  flex: 1;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h1,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h2,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h1:last-child,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h2:last-child,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-top: 32px !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-image {
  width: 80px;
  height: 50px;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text {
  flex: 1;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h1,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h2,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text p {
  font-size: 16px;
  margin-bottom: 4px !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer {
  margin-top: 32px !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h1,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h2,
[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer p {
  font-size: 14px;
  margin: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-card-feature'] .card-feature-wrapper {
    padding-block: 16px;
  }

  [data-type='section-card-feature'] .card-feature-wrapper[data-position='left'] .card-feature-container,
  [data-type='section-card-feature'] .card-feature-wrapper[data-position='right'] .card-feature-container {
    flex-direction: column-reverse;
  }

  [data-type='section-card-feature'] .card-feature-container {
    gap: 16px;
    padding: 8px !important;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h1,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h2,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-content p {
    font-size: 14px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item {
    font-size: 14px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h1,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h2,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-list .card-feature-item .card-feature-item-text p {
    font-size: 14px;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer {
    margin-top: 16px !important;
  }

  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h1,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h2,
  [data-type='section-card-feature'] .card-feature-container .card-feature-right .card-feature-footer h3 {
    font-size: 20px;
  }
}
`;
export default sectionCardFeatureCss;
